import type { Contact } from "../types";

export type ContactInput = {
  id: number;
  title?: string;
  firstName?: string;
  lastName?: string;
  isOrganization?: boolean;
  organization?: string;
  organizationSubName?: string;
  phones: { place: string; number: string }[];
  emails: { place: string; address: string }[];
  urls: { place: string; url: string }[];
  typedAddresses: {
    place?: string;
    postOfficeBox?: string;
    extendedAddress?: string;
    street?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    typedAddressId?: number;
  }[];
};

export function toContactInput(contact: Contact): ContactInput {
  return {
    id: contact.id,
    title: contact.title,
    firstName: contact.firstName,
    lastName: contact.lastName,
    isOrganization: contact.isOrganization,
    organization: contact.organization,
    organizationSubName: contact.isOrganization
      ? (contact.organizationSubName ?? "")
      : undefined,
    phones: contact.phones.map(({ place, number }) => ({ place, number })),
    emails: contact.emails.map(({ place, address }) => ({ place, address })),
    urls: contact.urls.map(({ place, url }) => ({ place, url })),
    typedAddresses: contact.typedAddresses.map((address) => ({
      place: address.place,
      postOfficeBox: address.postOfficeBox,
      extendedAddress: address.extendedAddress,
      street: address.street,
      city: address.city,
      state: address.state,
      postalCode: address.postalCode,
      country: address.country,
      typedAddressId: address.typedAddressId,
    })),
  };
}
